import BaseItemId from 'owa-service/lib/contract/BaseItemId';
import addEventToMyCalendarOperation from 'owa-service/lib/operation/addEventToMyCalendarOperation';
import addEventToMyCalendarRequest from 'owa-service/lib/factory/addEventToMyCalendarRequest';
import AddEventToMyCalendarRequest from 'owa-service/lib/contract/AddEventToMyCalendarRequest';
import AddEventToMyCalendarResponse from 'owa-service/lib/contract/AddEventToMyCalendarResponse';
import { getGroupRoutedRequestInit } from 'owa-group-common';

export default function addEventToMyCalendar(
    calendarEventId: BaseItemId,
    groupId: string
): Promise<AddEventToMyCalendarResponse> {
    const requestBody = configureRequestBody(calendarEventId);
    const requestOptions = getGroupRoutedRequestInit(groupId);
    return addEventToMyCalendarOperation(
        {
            request: requestBody,
        },
        requestOptions
    );
}

function configureRequestBody(itemId: BaseItemId): AddEventToMyCalendarRequest {
    return addEventToMyCalendarRequest({
        ItemId: itemId,
    });
}
